import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

/**
 * Home Component for the app
 */
const Home = ({ t }) => <div>
{t('screens.home.user-auth-title')}
</div>;
Home.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Home);
